export const getDefaultState = () => {
  return {
    vendorsList: null,
    activeVendor: null,
    activeVendorId: 0,
    subVendorList: null
  };
};

export const state = getDefaultState();
